import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import { imageCodes, videoCodes, titleCodes, textCodes } from "../../template_codes/eternalgosh/home_page_codes";
import slider from "../../assets/images/eternalgosh/slider2.png";
import mb from "../../assets/images/eternalgosh/4mb.png";

function Home() {

    return (

        <div>
            {/*             slider section            */}
            <div className="mb-10">
            <iframe src="https://www.youtube.com/embed/abkQZaT-me0?autoplay=1" 
                frameborder="0" allow="accelerometer; autoplay; 
                clipboard-write;" 
                loop autoplay muted
                className='absolute w-full h-96'>
            </iframe>
            <div className='overlay absolute w-full h-full bg-overlay blend-screen'></div>
                <div className='container w-4/5 text-center pb-10 z-40 relative text-white'>
                    <h1 className='text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold'>Eternal Gosh</h1>
                    <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-justify'>Eternal Gosh</p>
                    <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-justify'>Eternal Gosh</p>
                </div>
        </div>
            {/*             end of slider section            */}


            {/*             story section            */}
            <div className="mt-72"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols2 xl:grid-cols-2 2xl:grid-cols-2 mt-24">
                <div className="">
                    <Link to={paths.media}><h1 className="pb-4">STORY</h1></Link>
                    <Link to={paths.about}><p className="pb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit, Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        consectetur adipiscing elit.</p></Link>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        consectetur adipiscing elit.</p>
                </div>
                <div class="delay-[300ms] duration-[600ms] taos:translate-x-[200px] taos:opacity-0" data-taos-offset="400">
                    <img src={mb} width={480} height={240}></img>
                </div>
            </div>
            {/*             end of slider section            */}

            {/*             video section            */}
            <div className="container w-full xl:w-4/6 lg:w-4/6 pt-16">
                <iframe src="https://www.youtube.com/embed/LsH_E38e0SE" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
                    className="w-full h-96">
                </iframe>
            </div>
            {/*             end of video section            */}
        </div>
    );

}

export default Home;